(function($) {
    $('.accordion-section').each(function() {
        const $accordion = $(this).find('.as-item');
        $accordion.find('.as-description').hide();
        $accordion.first().addClass('active').find('.as-description').show();
        $(this)
            .find('.as-title')
            .on('click', function() {
                const $item = $(this).closest('.as-item');
                if ($item.hasClass('active')) {
                    $item
                        .removeClass('active')
                        .find('.as-description')
                        .slideUp();
                } else {
                    $accordion
                        .removeClass('active')
                        .find('.as-description')
                        .slideUp();

                    $item
                        .addClass('active')
                        .find('.as-description')
                        .slideDown();
                }
            });
    });
})(jQuery);
